import SectionHeading from "@/components/feature/SectionHeading";

const stats = [
  { value: "80+", label: "情报文章" },
  { value: "40+", label: "游戏IP追踪" },
  { value: "12+", label: "联动企划" },
  { value: "24h", label: "快讯响应" },
];

export default function StatsBand() {
  return (
    <section className="relative overflow-hidden bg-background-900 py-14 text-background-50 md:py-20">
      <div className="pointer-events-none absolute inset-0 opacity-15">
        <div className="absolute -left-10 top-0 h-64 w-64 rounded-full bg-accent-500/50 blur-3xl" />
        <div className="absolute -right-10 bottom-0 h-64 w-64 rounded-full bg-primary-500/50 blur-3xl" />
      </div>
      <div className="relative mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-2 gap-8 lg:grid-cols-4">
          {stats.map((s) => (
            <div key={s.label} className="text-center">
              <p className="font-heading text-3xl text-accent-400 md:text-5xl">{s.value}</p>
              <p className="mt-2 text-sm text-background-300">{s.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}